import React, { useRef } from 'react';
import TruncateTextCmp from 'src/components/TruncateText';

interface DashboardCardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    onClick: () => void;
}

const TopNavigationList: React.FC<DashboardCardProps> = ({ icon, title, description, onClick }) => {
    const descriptionRef = useRef<HTMLParagraphElement>(null);

    return (
        <li onClick={onClick} className="flex-1 rounded-xl border border-utilityGray200 shadow-xs p-3 flex items-start gap-x-3 hover:shadow-md-custom cursor-pointer bg-white">
            <div className="rounded-lg border border-utilityGray200 shadow-xs h-[40px] w-[40px] flex items-center justify-center min-h-[40px] min-w-[40px]">{icon}</div>
            <div className="flex-1 min-w-0 mt-0.5">
                <h6 className="text-primary text-sm font-semibold">{title}</h6>
                <TruncateTextCmp message={description} refName={descriptionRef}>
                    <p ref={descriptionRef} className="text-grayLight600 text-[12px] leading-[18px] font-normal truncate">
                        {description}
                    </p>
                </TruncateTextCmp>
            </div>
        </li>
    );
};

export default TopNavigationList;
